<form [formGroup]="createForm" (submit)="onSubmit()">
  <div class="p-fluid">
    <div class="p-field">
      <span class="p-float-label">
        <input pInputText type="text" required id="switchname" [placeholder]="'virtual_switch_name'| translate" formControlName="name" maxlength="100" class="p-inputtext-lg" />
        <label for="switchname" [translate]="'name'" class="required"></label>
      </span>
    </div>
    <div class="p-field">
      <label for="project_uuid" [translate]="'project'" class="ig-label-title required"></label>
      <ig-autocomplete
        [suggestions]="projects"
        formControlName="project_uuid"
        inputId="project_uuid"
        [placeholder]="('choose_a_first_project' | translate)"
      >
        <ng-template let-group pTemplate="group">
            <span>{{group?.label}}</span>
        </ng-template>
        <ng-template let-group pTemplate="item">
            <span class="p-pl-2">{{group?.label}}</span>
        </ng-template>
      </ig-autocomplete>
    </div>
  </div>

  <ig-form-validation-errors [control]="createForm"></ig-form-validation-errors>
</form>
